module.exports = __webpack_public_path__ + "img/ch13_07_兜兜送草编花.3d585316.jpg";